import React from "react";
import ThemeAppearancePanel from "../../components/Setting/ThemeAppearancePanel";
import PortalThemeShell from "./PortalThemeShell";
import { useAdminDarkMode } from "../../contexts/AdminDarkModeContext";

const HELP =
  "When Sync with system is on, the Super Admin portal follows your browser or OS theme. When it is off, Light or Dark applies only while you are signed in here. The sign-in screen always follows your device theme. Your choice is saved to your account.";

export default function SuperAdminPortalTheme() {
  const { adminThemePreference, setAdminThemePreference } = useAdminDarkMode();

  return (
    <PortalThemeShell title="Theme & appearance">
      <ThemeAppearancePanel
        adminThemePreference={adminThemePreference}
        setAdminThemePreference={setAdminThemePreference}
        helpText={HELP}
      />
    </PortalThemeShell>
  );
}
